module.exports = __webpack_public_path__ + "img/noun_Arrow.79a9dcde.svg";